(() => {
  function init(root = document) {
    root.querySelectorAll('[data-gazette-pages]').forEach(section => {
      if (section.dataset.gazetteReady) return;
      section.dataset.gazetteReady = 'true';
      const rail = section.querySelector('[data-gazette-rail]');
      const cards = [...rail.querySelectorAll('[data-gazette-card]')];
      const count = section.querySelector('[data-gazette-count]');
      if (!cards.length) return;
      const update = () => {
        const left = rail.getBoundingClientRect().left;
        const nearest = cards.reduce((best, card, index) => Math.abs(card.getBoundingClientRect().left - left) < Math.abs(cards[best].getBoundingClientRect().left - left) ? index : best, 0);
        count.textContent = `${nearest + 1} / ${cards.length}`;
      };
      rail.addEventListener('scroll', update, { passive: true });
      rail.addEventListener('keydown', event => {
        if (event.target !== rail || !matchMedia('(max-width:768px)').matches || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
        event.preventDefault();
        const distance = cards[0].getBoundingClientRect().width + 14;
        rail.scrollBy({ left: distance * (event.key === 'ArrowRight' ? 1 : -1), behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'instant' : 'smooth' });
      });
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
